import Grid from "theme/layouts/Grid";
import PropTypes from "prop-types";
import React from "react";
import TeamMemberBlock from "theme/libs/wordpress/content/cmsBlocks/TeamMemberBlock";
import TextLink from "theme/components/text/TextLink";
import TextStyles from "theme/components/text/TextStyles";
import Waterfall from "theme/layouts/Waterfall";
import colors from "theme/config/colors";
import transformHeading from "theme/libs/wordpress/utils/transformHeading";

const TeamMembersLayout = ({ content }) => {
    const { heading: moduleHeading, team_members: teamMembers } = content?.data || {};
    const moduleHeader = transformHeading(moduleHeading.heading);

    const moduleLink = {
        text: moduleHeading?.link?.text || undefined,
        url: moduleHeading?.link?.url || undefined,
    };

    return (
        <Waterfall
            as="section"
            data-is-fullwidth="true" // to set fullwidth in subgrid
            rowGap={["32px", null, null, null, "48px"]}
        >
            {moduleHeader?.text && (
                <TextStyles
                    as={moduleHeader?.type || "h2"}
                    textStyles={["Myriad Pro/24-120-semibold", null, null, null, "Myriad Pro/32-120-semibold"]}
                    pb={["0", null, null, null, "16px"]}
                    borderBottom={["none", null, null, null, `1px solid ${colors.black_10}`]}
                >
                    {moduleHeader.text}
                </TextStyles>
            )}
            {moduleLink.url && moduleLink.text && (
                <TextLink to={moduleLink.url} whiteSpace="nowrap" color="#282828b3">
                    {moduleLink.text}
                </TextLink>
            )}

            <Grid columns={[1, null, null, 2]} rowGap={["64px", null, null, null, "48px"]} columnGap="24px">
                {teamMembers?.map(({ data }) => (
                    <TeamMemberBlock key={`${data?.name}-${data?.role}`} {...data} />
                ))}
            </Grid>
        </Waterfall>
    );
};

TeamMembersLayout.propTypes = {
    content: PropTypes.object,
};

TeamMembersLayout.defaultProps = {
    content: undefined,
};

export default TeamMembersLayout;
